module.exports = __webpack_public_path__ + "img/banner.080a5bdb.jpg";